import axios from 'axios'
import {
  onRequestError,
  onRequestSuccess,
  onResponseError,
  onResponseSuccess,
} from './interceptors'

const defaultApiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export function createApiClient (baseURL = defaultApiUrl) {
  const client = axios.create({ baseURL })

  // Interceptores de petición
  client.interceptors.request.use(
    onRequestSuccess,
    onRequestError,
  )

  // Interceptores de respuesta
  client.interceptors.response.use(
    onResponseSuccess,
    onResponseError,
  )

  return client
}

export function createAuthApiClient (baseURL = defaultApiUrl) {
  const client = axios.create({ baseURL })

  // Configuración para autenticación
  client.defaults.headers.common['Accept'] = 'application/json'
  client.defaults.headers.common['Content-Type'] = 'application/json'
  client.defaults.withCredentials = true
  client.defaults.withXSRFToken = true

  // Interceptores de petición
  client.interceptors.request.use(
    onRequestSuccess,
    onRequestError,
  )

  // Interceptores de respuesta
  client.interceptors.response.use(
    onResponseSuccess,
    onResponseError,
  )

  return client
}

export default class BaseService {
  constructor (baseURL = null, subRoute = null, useAuthClient = false) {
    this.baseURL = baseURL || defaultApiUrl + (subRoute ? `${subRoute}` : '')
    this.client = useAuthClient
      ? createAuthApiClient(this.baseURL)
      : createApiClient(this.baseURL)
  }

  request (config) {
    return this.client.request(config).then(res => res.data)
  }

  get (url, params, config) {
    return this.client.get(url, { params, ...config }).then(res => res.data)
  }

  post (url, data, config) {
    return this.client.post(url, data, config).then(res => res.data)
  }

  put (url, data, config) {
    return this.client.put(url, data, config).then(res => res.data)
  }

  patch (url, data, config) {
    return this.client.patch(url, data, config).then(res => res.data)
  }

  delete (url, config) {
    return this.client.delete(url, config).then(res => res.data)
  }
}
